import { Chip } from "@mui/material";

type ChipColor = "default" | "primary" | "success" | "warning" | "error" | "info";

const COLORS: Record<string, ChipColor> = {
  draft: "default",
  classifying: "info",
  running: "primary",
  queued: "default",
  needs_review: "warning",
  awaiting_review: "warning",
  succeeded: "success",
  completed: "success",
  completed_with_errors: "warning",
  failed: "error",
  cancelling: "warning",
  cancelled: "default",
  skipped: "default",
};

export function statusLabel(status: string): string {
  return status.replace(/_/g, " ");
}

/** Status pill shared by batch rows and item rows; `data-status` lets a
 *  browser agent read state without parsing the label. */
export function StatusChip({ status, testId }: { status: string; testId?: string }) {
  return (
    <Chip
      size="small"
      label={statusLabel(status)}
      color={COLORS[status] ?? "default"}
      // Filled colored chips render near-invisible in this theme (seen live);
      // outlined keeps the color on the border and label, readable everywhere.
      variant={(COLORS[status] ?? "default") === "default" && status !== "queued" && status !== "cancelled" ? "filled" : "outlined"}
      data-testid={testId ?? "batch-status-chip"}
      data-status={status}
    />
  );
}
